import React from 'react';
import { Col, Card, CardHeader } from 'reactstrap';
import { P } from "../../../../AbstractElements";
import RecentJoinsCardBody from './RecentJoinsCardBody';

const RecentJoins = () => {

    return (
        <Col lg="12" md="12" className="box-col-12">
            <Card className="best-seller">
                <CardHeader className="pb-0">
                    <div className="d-flex justify-content-between">
                        <div className="flex-grow-1">
                            <P attrPara={{ className: "square-after f-w-600" }}>Recent Join Parikramavasi's <i className="fa fa-circle"></i> </P>
                        </div>
                    </div>
                </CardHeader>
                <RecentJoinsCardBody />
            </Card>
        </Col>
    );
};

export default RecentJoins;
